import { instance, ApiResponse } from '.'
import { insertKeyEndpoint } from './utils'
import { ActivityMovement } from 'store/activity/types'

export const getActivity = async () => {
  return instance.get<ApiResponse<ActivityMovement[]>>(
    insertKeyEndpoint('user-app/activity')
  )
}
